import React from 'react';
import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
 
import SignUp from './pages/signup/SignUp';
import Login from './pages/Login/Login';
import Layout from './pages/Layout/Layout';
import SettingsPage from './pages/SettingsPage/SettingsPage';
import SavedChatsPage from './pages/SavedChatsPage/SavedChatsPage';
import ProtectedRoute from './ProtectedRoutes';
import RightChatComponent from './component/RightChatComponent/RightChatComponent';
import ResetPassword from './pages/ResetPassword/ResetPassword';
import LimitExceed from './component/limitExceedPage/LimitExceed';
import Users from './pages/users/Users';
 
function AppRoute() {
  const router = createBrowserRouter([
    {
      path: '/',
      element: <Login />
    },
    {
      path: 'sign-up',
      element: <SignUp />
    },
    {
      path:'reset-password',
      element: <ResetPassword />
    },
    {
      path: '/app',
      element: <ProtectedRoute component={<Layout />} />,
      errorElement: <div>Page not found - 404 Naved!</div>,
      children: [
        {
          path: 'chat',
          // Auto-generate UUID and redirect to `/app/chat/:id`
          element: <Navigate to={`/app/chat/${uuidv4()}`} replace />
        },
        {
          path: 'chat/:id',
          element: <ProtectedRoute component={<RightChatComponent />} />
        },
        {
          path: 'settings',
          element: <ProtectedRoute component={<SettingsPage />} />
        },
        {
          path: 'savedchats',
          element: <ProtectedRoute component={<SavedChatsPage />} />
        },
        {
          path: 'limitExceeded',
          element: <ProtectedRoute component={<LimitExceed />} />
        },
        {
          path: 'users/:requestType',
          element: <ProtectedRoute component={<Users />} />
        }
      ],
    },
  ]);
 
  return <RouterProvider router={router} />;
}
 
export default AppRoute;